export const BEARER_TYPE = {
	SMS: 'sms',
	DIGITAL: 'digital',
}

export const ORG_TYPE = {
	OOO: 'ooo',
	IP: 'ip',
}
